// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gemicPage {
  min-height: 100%;
  padding: 22px;
  color: #f4f4f4;
  background:
    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),
    #050505;
}

/* ================= SHARED ================= */

.gemicHeroContent,
.gemicPanel {
  border: 1px solid rgba(177, 136, 0, 0.28);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),
    #0b0b0b;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);
}

.gemicHeroContent,
.gemicPanel {
  padding: 20px;
}

.gemicEyebrow,
.gemicSectionLabel,
.gemicStatCard span,
.gemicInfoBlock span,
.gemicStructureCard span,
.gemicRecentTradeTable th {
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.gemicEyebrow,
.gemicSectionLabel,
.gemicInfoBlock span {
  color: #d8b44c;
  font-size: 0.72rem;
}

.gemicPanelHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.gemicPanelHeader h3 {
  margin: 6px 0 0;
  color: #ffffff;
  font-size: 1.15rem;
  line-height: 1.2;
}

.gemicPanelText {
  max-width: 980px;
  margin: 12px 0 0;
  color: rgba(244, 244, 244, 0.72);
  font-size: 0.93rem;
  line-height: 1.58;
}

.gemicPanelText:first-of-type {
  margin-top: 0;
}

.gemicPanelSubtext {
  margin: 14px 0 0;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.075);
  color: rgba(244, 244, 244, 0.5);
  font-size: 0.78rem;
  line-height: 1.45;
}

.gemicPanelPill {
  white-space: nowrap;
  padding: 7px 10px;
  border: 1px solid rgba(177, 136, 0, 0.42);
  border-radius: 999px;
  color: #f4d06f;
  background: rgba(177, 136, 0, 0.08);
  font-size: 0.72rem;
  font-weight: 800;
}

/* ================= PAGE LAYOUT ================= */

.gemicPageGrid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(380px, 0.65fr);
  gap: 18px;
  align-items: start;
}

.gemicLeftColumn,
.gemicRightColumn {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ================= HERO ================= */

.gemicHeroContent {
  padding: 24px 28px;
}

.gemicEyebrow {
  display: inline-flex;
  width: fit-content;
  letter-spacing: 0.11em;
}

.gemicHeroContent h1 {
  margin: 10px 0 0;
  color: #ffffff;
  font-size: clamp(2.4rem, 4vw, 4rem);
  line-height: 0.95;
  letter-spacing: 0.02em;
}

.gemicHeroContent h2 {
  margin: 8px 0 0;
  color: #b18800;
  font-size: clamp(1.2rem, 2vw, 1.7rem);
  font-weight: 800;
}

.gemicHeroContent p {
  max-width: 940px;
  margin: 14px 0 0;
  color: rgba(244, 244, 244, 0.74);
  font-size: 0.96rem;
  line-height: 1.58;
}

.gemicHeroActions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}

.gemicPrimaryButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 11px 15px;
  border: 1px solid rgba(177, 136, 0, 0.52);
  border-radius: 12px;
  color: #f4d06f;
  background:
    linear-gradient(145deg, rgba(177, 136, 0, 0.18), rgba(255, 255, 255, 0.035)),
    rgba(177, 136, 0, 0.08);
  font-size: 0.82rem;
  font-weight: 900;
  text-decoration: none;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
  transition:
    background 160ms ease,
    border-color 160ms ease,
    transform 160ms ease;
}

.gemicPrimaryButton:hover {
  border-color: rgba(216, 180, 76, 0.78);
  background:
    linear-gradient(145deg, rgba(177, 136, 0, 0.26), rgba(255, 255, 255, 0.05)),
    rgba(177, 136, 0, 0.12);
  transform: translateY(-1px);
}

/* ================= STATS ================= */

.gemicStatsGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.gemicMiniStatsGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.gemicMiniStatsGrid--single {
  grid-template-columns: 1fr;
}

.gemicStatCard,
.gemicInfoBlock,
.gemicProcessCard,
.gemicStructureCard {
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.gemicStatCard {
  min-width: 0;
  padding: 16px;
}

.gemicStatCard span {
  display: block;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.68rem;
}

.gemicStatCard strong {
  display: block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 1.35rem;
  line-height: 1.05;
}

.gemicStatCard small {
  display: block;
  margin-top: 8px;
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.75rem;
  line-height: 1.35;
}

.gemicStatCard--positive strong {
  color: #55d17a;
}

.gemicStatCard--negative strong {
  color: #ff6464;
}

/* ================= PROCESS ================= */

.gemicProcessGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.gemicProcessCard {
  padding: 16px;
}

.gemicProcessStep {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 28px;
  border: 1px solid rgba(177, 136, 0, 0.36);
  border-radius: 999px;
  color: #f4d06f;
  background: rgba(177, 136, 0, 0.08);
  font-size: 0.72rem;
  font-weight: 900;
}

.gemicProcessCard h4 {
  margin: 12px 0 0;
  color: #ffffff;
  font-size: 0.96rem;
  line-height: 1.25;
}

.gemicProcessCard p {
  margin: 8px 0 0;
  color: rgba(244, 244, 244, 0.62);
  font-size: 0.82rem;
  line-height: 1.5;
}

/* ================= STRUCTURE ================= */

.gemicStructureGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.gemicStructureCard {
  position: relative;
  min-height: 124px;
  padding: 16px;
  overflow: hidden;
}

.gemicStructureCard::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top right, rgba(177, 136, 0, 0.12), transparent 45%);
  pointer-events: none;
}

.gemicStructureCard span {
  position: relative;
  z-index: 1;
  display: block;
  color: #d8b44c;
  font-size: 0.7rem;
}

.gemicStructureCard p {
  position: relative;
  z-index: 1;
  margin: 10px 0 0;
  color: rgba(244, 244, 244, 0.66);
  font-size: 0.82rem;
  line-height: 1.48;
}

.gemicNoticeBox {
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 193, 7, 0.28);
  border-radius: 12px;
  color: #f4d06f;
  background: rgba(255, 193, 7, 0.08);
  font-size: 0.82rem;
  font-weight: 800;
  line-height: 1.4;
}

/* ================= RECENT TRADES TABLE ================= */

.gemicRecentTradeTableWrap {
  width: 100%;
  margin-top: 16px;
  overflow-x: auto;
}

.gemicRecentTradeTable {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
}

.gemicRecentTradeTable th {
  padding: 11px 12px;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.72rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.gemicRecentTradeTable td {
  padding: 13px 12px;
  color: rgba(244, 244, 244, 0.82);
  font-size: 0.86rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.055);
}

.gemicRecentTradeTable tbody tr:hover {
  background: rgba(177, 136, 0, 0.055);
}

.gemicResultPill {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 999px;
  color: rgba(244, 244, 244, 0.75);
  background: rgba(255, 255, 255, 0.07);
  font-size: 0.75rem;
  font-weight: 800;
  white-space: nowrap;
}

.gemicResultPill--positive {
  color: #55d17a;
  background: rgba(85, 209, 122, 0.1);
}

.gemicResultPill--negative {
  color: #ff6464;
  background: rgba(255, 100, 100, 0.1);
}

.gemicPnlCell {
  font-weight: 900;
}

.gemicPnlCell--positive {
  color: #55d17a !important;
}

.gemicPnlCell--negative {
  color: #ff6464 !important;
}

.gemicEmptyTableCell {
  padding: 18px 12px;
  color: rgba(244, 244, 244, 0.48);
  text-align: center;
}

/* ================= RIGHT COLUMN ================= */

.gemicPerformancePanel {
  border-color: rgba(216, 180, 76, 0.42);
  background:
    radial-gradient(circle at top right, rgba(177, 136, 0, 0.14), transparent 38%),
    #0b0b0b;
}

.gemicInfoStack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.gemicInfoBlock {
  padding: 14px;
}

.gemicInfoBlock span {
  display: block;
  margin-bottom: 7px;
}

.gemicInfoBlock p {
  margin: 0;
  color: rgba(244, 244, 244, 0.66);
  font-size: 0.84rem;
  line-height: 1.5;
}

/* ================= CTA ================= */

.gemicCtaPanel {
  border-color: rgba(216, 180, 76, 0.42);
}

.gemicCtaPanel h3 {
  margin: 8px 0 0;
  color: #ffffff;
  font-size: 1.25rem;
}

.gemicCtaPanel p {
  margin: 12px 0 0;
  color: rgba(244, 244, 244, 0.68);
  font-size: 0.9rem;
  line-height: 1.55;
}

/* ================= DISCLAIMER ================= */

.gemicDisclaimer {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 14px;
  color: rgba(244, 244, 244, 0.42);
  background: rgba(255, 255, 255, 0.025);
  font-size: 0.74rem;
  line-height: 1.45;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 1240px) {
  .gemicPageGrid {
    grid-template-columns: 1fr;
  }

  .gemicMiniStatsGrid,
  .gemicMiniStatsGrid--single {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 980px) {
  .gemicProcessGrid,
  .gemicStructureGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 860px) {
  .gemicPage {
    padding: 16px;
  }

  .gemicStatsGrid,
  .gemicMiniStatsGrid,
  .gemicMiniStatsGrid--single {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .gemicHeroContent,
  .gemicPanel {
    border-radius: 16px;
  }
}

@media (max-width: 560px) {
  .gemicStatsGrid,
  .gemicMiniStatsGrid,
  .gemicMiniStatsGrid--single,
  .gemicProcessGrid,
  .gemicStructureGrid {
    grid-template-columns: 1fr;
  }

  .gemicPanelHeader {
    flex-direction: column;
  }

  .gemicHeroContent,
  .gemicPanel {
    padding: 16px;
  }

  .gemicHeroContent {
    padding: 20px 18px;
  }

  .gemicPrimaryButton {
    width: 100%;
  }
}





/* ================= MOBILE WIDTH / OVERFLOW FIX ================= */

.gemicPage,
.gemicPageGrid,
.gemicLeftColumn,
.gemicRightColumn,
.gemicHeroContent,
.gemicPanel {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.gemicPage {
  overflow-x: hidden;
}

.gemicHeroContent {
  position: relative;
  overflow: hidden;
}

.gemicHeroContent h1,
.gemicHeroContent h2,
.gemicHeroContent p,
.gemicPanelText {
  max-width: 100%;
  overflow-wrap: break-word;
}

.gemicHeroActions {
  flex-wrap: wrap;
}

.gemicPrimaryButton {
  max-width: 100%;
  white-space: normal;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/GEMICPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd;;WAES;AACX;;AAEA,+CAA+C;;AAE/C;;EAEE,yCAAyC;EACzC,mBAAmB;EACnB;;WAES;EACT,2CAA2C;AAC7C;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;;EAME,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6CAA6C;;AAE7C;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd;;2BAEyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C;;;wBAGsB;AACxB;;AAEA;EACE,sCAAsC;EACtC;;2BAEyB;EACzB,2BAA2B;AAC7B;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4DAA4D;;AAE5D;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,qDAAqD;;AAErD;EACE,sCAAsC;EACtC;;WAES;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,4CAA4C;;AAE5C;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,mDAAmD;;AAEnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mDAAmD;;AAEnD;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,gDAAgD;EAClD;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;;;;;AAMA,oEAAoE;;AAEpE;;;;;;EAME,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".gemicPage {\n  min-height: 100%;\n  padding: 22px;\n  color: #f4f4f4;\n  background:\n    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),\n    #050505;\n}\n\n/* ================= SHARED ================= */\n\n.gemicHeroContent,\n.gemicPanel {\n  border: 1px solid rgba(177, 136, 0, 0.28);\n  border-radius: 18px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),\n    #0b0b0b;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);\n}\n\n.gemicHeroContent,\n.gemicPanel {\n  padding: 20px;\n}\n\n.gemicEyebrow,\n.gemicSectionLabel,\n.gemicStatCard span,\n.gemicInfoBlock span,\n.gemicStructureCard span,\n.gemicRecentTradeTable th {\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.gemicEyebrow,\n.gemicSectionLabel,\n.gemicInfoBlock span {\n  color: #d8b44c;\n  font-size: 0.72rem;\n}\n\n.gemicPanelHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.gemicPanelHeader h3 {\n  margin: 6px 0 0;\n  color: #ffffff;\n  font-size: 1.15rem;\n  line-height: 1.2;\n}\n\n.gemicPanelText {\n  max-width: 980px;\n  margin: 12px 0 0;\n  color: rgba(244, 244, 244, 0.72);\n  font-size: 0.93rem;\n  line-height: 1.58;\n}\n\n.gemicPanelText:first-of-type {\n  margin-top: 0;\n}\n\n.gemicPanelSubtext {\n  margin: 14px 0 0;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.075);\n  color: rgba(244, 244, 244, 0.5);\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n\n.gemicPanelPill {\n  white-space: nowrap;\n  padding: 7px 10px;\n  border: 1px solid rgba(177, 136, 0, 0.42);\n  border-radius: 999px;\n  color: #f4d06f;\n  background: rgba(177, 136, 0, 0.08);\n  font-size: 0.72rem;\n  font-weight: 800;\n}\n\n/* ================= PAGE LAYOUT ================= */\n\n.gemicPageGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(380px, 0.65fr);\n  gap: 18px;\n  align-items: start;\n}\n\n.gemicLeftColumn,\n.gemicRightColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n/* ================= HERO ================= */\n\n.gemicHeroContent {\n  padding: 24px 28px;\n}\n\n.gemicEyebrow {\n  display: inline-flex;\n  width: fit-content;\n  letter-spacing: 0.11em;\n}\n\n.gemicHeroContent h1 {\n  margin: 10px 0 0;\n  color: #ffffff;\n  font-size: clamp(2.4rem, 4vw, 4rem);\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n}\n\n.gemicHeroContent h2 {\n  margin: 8px 0 0;\n  color: #b18800;\n  font-size: clamp(1.2rem, 2vw, 1.7rem);\n  font-weight: 800;\n}\n\n.gemicHeroContent p {\n  max-width: 940px;\n  margin: 14px 0 0;\n  color: rgba(244, 244, 244, 0.74);\n  font-size: 0.96rem;\n  line-height: 1.58;\n}\n\n.gemicHeroActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.gemicPrimaryButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 11px 15px;\n  border: 1px solid rgba(177, 136, 0, 0.52);\n  border-radius: 12px;\n  color: #f4d06f;\n  background:\n    linear-gradient(145deg, rgba(177, 136, 0, 0.18), rgba(255, 255, 255, 0.035)),\n    rgba(177, 136, 0, 0.08);\n  font-size: 0.82rem;\n  font-weight: 900;\n  text-decoration: none;\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    transform 160ms ease;\n}\n\n.gemicPrimaryButton:hover {\n  border-color: rgba(216, 180, 76, 0.78);\n  background:\n    linear-gradient(145deg, rgba(177, 136, 0, 0.26), rgba(255, 255, 255, 0.05)),\n    rgba(177, 136, 0, 0.12);\n  transform: translateY(-1px);\n}\n\n/* ================= STATS ================= */\n\n.gemicStatsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.gemicMiniStatsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.gemicMiniStatsGrid--single {\n  grid-template-columns: 1fr;\n}\n\n.gemicStatCard,\n.gemicInfoBlock,\n.gemicProcessCard,\n.gemicStructureCard {\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.gemicStatCard {\n  min-width: 0;\n  padding: 16px;\n}\n\n.gemicStatCard span {\n  display: block;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.68rem;\n}\n\n.gemicStatCard strong {\n  display: block;\n  margin-top: 10px;\n  color: #ffffff;\n  font-size: 1.35rem;\n  line-height: 1.05;\n}\n\n.gemicStatCard small {\n  display: block;\n  margin-top: 8px;\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.75rem;\n  line-height: 1.35;\n}\n\n.gemicStatCard--positive strong {\n  color: #55d17a;\n}\n\n.gemicStatCard--negative strong {\n  color: #ff6464;\n}\n\n/* ================= PROCESS ================= */\n\n.gemicProcessGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.gemicProcessCard {\n  padding: 16px;\n}\n\n.gemicProcessStep {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 28px;\n  border: 1px solid rgba(177, 136, 0, 0.36);\n  border-radius: 999px;\n  color: #f4d06f;\n  background: rgba(177, 136, 0, 0.08);\n  font-size: 0.72rem;\n  font-weight: 900;\n}\n\n.gemicProcessCard h4 {\n  margin: 12px 0 0;\n  color: #ffffff;\n  font-size: 0.96rem;\n  line-height: 1.25;\n}\n\n.gemicProcessCard p {\n  margin: 8px 0 0;\n  color: rgba(244, 244, 244, 0.62);\n  font-size: 0.82rem;\n  line-height: 1.5;\n}\n\n/* ================= STRUCTURE ================= */\n\n.gemicStructureGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.gemicStructureCard {\n  position: relative;\n  min-height: 124px;\n  padding: 16px;\n  overflow: hidden;\n}\n\n.gemicStructureCard::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at top right, rgba(177, 136, 0, 0.12), transparent 45%);\n  pointer-events: none;\n}\n\n.gemicStructureCard span {\n  position: relative;\n  z-index: 1;\n  display: block;\n  color: #d8b44c;\n  font-size: 0.7rem;\n}\n\n.gemicStructureCard p {\n  position: relative;\n  z-index: 1;\n  margin: 10px 0 0;\n  color: rgba(244, 244, 244, 0.66);\n  font-size: 0.82rem;\n  line-height: 1.48;\n}\n\n.gemicNoticeBox {\n  margin-top: 14px;\n  padding: 12px 14px;\n  border: 1px solid rgba(255, 193, 7, 0.28);\n  border-radius: 12px;\n  color: #f4d06f;\n  background: rgba(255, 193, 7, 0.08);\n  font-size: 0.82rem;\n  font-weight: 800;\n  line-height: 1.4;\n}\n\n/* ================= RECENT TRADES TABLE ================= */\n\n.gemicRecentTradeTableWrap {\n  width: 100%;\n  margin-top: 16px;\n  overflow-x: auto;\n}\n\n.gemicRecentTradeTable {\n  width: 100%;\n  min-width: 760px;\n  border-collapse: collapse;\n}\n\n.gemicRecentTradeTable th {\n  padding: 11px 12px;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.72rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.gemicRecentTradeTable td {\n  padding: 13px 12px;\n  color: rgba(244, 244, 244, 0.82);\n  font-size: 0.86rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.055);\n}\n\n.gemicRecentTradeTable tbody tr:hover {\n  background: rgba(177, 136, 0, 0.055);\n}\n\n.gemicResultPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 9px;\n  border-radius: 999px;\n  color: rgba(244, 244, 244, 0.75);\n  background: rgba(255, 255, 255, 0.07);\n  font-size: 0.75rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.gemicResultPill--positive {\n  color: #55d17a;\n  background: rgba(85, 209, 122, 0.1);\n}\n\n.gemicResultPill--negative {\n  color: #ff6464;\n  background: rgba(255, 100, 100, 0.1);\n}\n\n.gemicPnlCell {\n  font-weight: 900;\n}\n\n.gemicPnlCell--positive {\n  color: #55d17a !important;\n}\n\n.gemicPnlCell--negative {\n  color: #ff6464 !important;\n}\n\n.gemicEmptyTableCell {\n  padding: 18px 12px;\n  color: rgba(244, 244, 244, 0.48);\n  text-align: center;\n}\n\n/* ================= RIGHT COLUMN ================= */\n\n.gemicPerformancePanel {\n  border-color: rgba(216, 180, 76, 0.42);\n  background:\n    radial-gradient(circle at top right, rgba(177, 136, 0, 0.14), transparent 38%),\n    #0b0b0b;\n}\n\n.gemicInfoStack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.gemicInfoBlock {\n  padding: 14px;\n}\n\n.gemicInfoBlock span {\n  display: block;\n  margin-bottom: 7px;\n}\n\n.gemicInfoBlock p {\n  margin: 0;\n  color: rgba(244, 244, 244, 0.66);\n  font-size: 0.84rem;\n  line-height: 1.5;\n}\n\n/* ================= CTA ================= */\n\n.gemicCtaPanel {\n  border-color: rgba(216, 180, 76, 0.42);\n}\n\n.gemicCtaPanel h3 {\n  margin: 8px 0 0;\n  color: #ffffff;\n  font-size: 1.25rem;\n}\n\n.gemicCtaPanel p {\n  margin: 12px 0 0;\n  color: rgba(244, 244, 244, 0.68);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n/* ================= DISCLAIMER ================= */\n\n.gemicDisclaimer {\n  margin-top: 18px;\n  padding: 14px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 14px;\n  color: rgba(244, 244, 244, 0.42);\n  background: rgba(255, 255, 255, 0.025);\n  font-size: 0.74rem;\n  line-height: 1.45;\n}\n\n/* ================= RESPONSIVE ================= */\n\n@media (max-width: 1240px) {\n  .gemicPageGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .gemicMiniStatsGrid,\n  .gemicMiniStatsGrid--single {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 980px) {\n  .gemicProcessGrid,\n  .gemicStructureGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 860px) {\n  .gemicPage {\n    padding: 16px;\n  }\n\n  .gemicStatsGrid,\n  .gemicMiniStatsGrid,\n  .gemicMiniStatsGrid--single {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .gemicHeroContent,\n  .gemicPanel {\n    border-radius: 16px;\n  }\n}\n\n@media (max-width: 560px) {\n  .gemicStatsGrid,\n  .gemicMiniStatsGrid,\n  .gemicMiniStatsGrid--single,\n  .gemicProcessGrid,\n  .gemicStructureGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .gemicPanelHeader {\n    flex-direction: column;\n  }\n\n  .gemicHeroContent,\n  .gemicPanel {\n    padding: 16px;\n  }\n\n  .gemicHeroContent {\n    padding: 20px 18px;\n  }\n\n  .gemicPrimaryButton {\n    width: 100%;\n  }\n}\n\n\n\n\n\n/* ================= MOBILE WIDTH / OVERFLOW FIX ================= */\n\n.gemicPage,\n.gemicPageGrid,\n.gemicLeftColumn,\n.gemicRightColumn,\n.gemicHeroContent,\n.gemicPanel {\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.gemicPage {\n  overflow-x: hidden;\n}\n\n.gemicHeroContent {\n  position: relative;\n  overflow: hidden;\n}\n\n.gemicHeroContent h1,\n.gemicHeroContent h2,\n.gemicHeroContent p,\n.gemicPanelText {\n  max-width: 100%;\n  overflow-wrap: break-word;\n}\n\n.gemicHeroActions {\n  flex-wrap: wrap;\n}\n\n.gemicPrimaryButton {\n  max-width: 100%;\n  white-space: normal;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
